var FcSendEmailMessageDialogModule = /** @class */ (function () {
    function FcSendEmailMessageDialogModule() {
    }
    return FcSendEmailMessageDialogModule;
}());
export { FcSendEmailMessageDialogModule };
